import { RequestParams } from '../types';

export const getQueryKey = (url: string, query?: RequestParams['query']) => {
    return [url, query].filter(Boolean);
};
